import {TOGGLE_COLLAPSE_FILTERS} from "../../constants/ActionTypes";

export const toggleCollapseFilters = (filtersCollapsed) => {
  return {
    type: TOGGLE_COLLAPSE_FILTERS,
    payload: filtersCollapsed
  }
};
